import React, { useContext } from 'react';
import { useLocalize } from '@core-ui/localization-provider';
import {
  DROPSHIP_STARTS_FROM,
  DROPSHIP_STARTING_AT,
} from './localization-tokens';
import { PriceStyleContainer } from './styles';
import { BrandInfoContext } from '@core-ui/brand-info-provider';

const PriceLine = ({ dropshipData }) => {
  const { localize } = useLocalize();
  const { abbrBrand } = useContext(BrandInfoContext);
  const isBR = abbrBrand === 'br' || abbrBrand === 'brfs';
  const preparePriceLineText = () => {
    if (isBR) {
      return `${localize(DROPSHIP_STARTING_AT)}`;
    }
    return `${localize(DROPSHIP_STARTS_FROM)}`;
  };
  const priceLineText = preparePriceLineText();
  return (
    <>
      {dropshipData.isLowestPriceCC === 'true' && (
        <div data-test-id="price-line">
          <PriceStyleContainer>
            <span>{priceLineText}</span>
          </PriceStyleContainer>
        </div>
      )}
    </>
  );
};

export default PriceLine;
